import React, {Component} from 'react'
import * as colors from '../colors'
import {style, media, merge} from 'glamor'
import Label from './Label'
import {Link} from 'react-router'

export default class RevealThumb extends Component {

  render(){
    const {
      to='/corporate/luxe',
      title='Luxe | Mode',
      image='/images/category/e-commerce.jpg',
      ...props
    } = this.props
    return (
      <Link
        to={to}
        {...props}
        {...style({
          position: 'relative',
          display: 'block',
          width: '100%',
          overflow: 'hidden',
          marginBottom: '1.5rem'
        })}
        {...media('(min-width:600px)',{
          // display: 'inline-block',
          // paddingRight: '1.5rem',
          // width: '50%',
        })}
      >
      <div
        {...style({
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom :0,
          zIndex: 1,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.4) 100%)'
        })}
      />
        <img
          {...style({
            display: 'block',
            width: '100%'
          })}
          src={image}
        />
        <div
          {...style({
            position: 'absolute',
            bottom: 0,
            left: 0,
            zIndex: 2,
            margin: '1rem'
          })}
        >
          <Label>
            {title}
          </Label>
        </div>
      </Link>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ThumbCategory.js
 **/